import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CommonComponentsModule} from '../../common-components.module';
import {TabsModule} from '../../components/tabs/tabs.module';
import {FormsModule} from '@angular/forms';
import {FieldsModule} from '../../components/fields/fields.module';
import {DetailedViewComponent} from './detailed-view/detailed-view.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {NotificationModalComponent} from './notification-modal/notification-modal.component';
import {SettingsIncidentReportComponent} from './settings-incident-report.component';
import {SettingsIncidentReportListComponent} from './settings-incident-report-list/settings-incident-report-list.component';
import {SettingsIncidentReportService} from '../../services/settings-incident-report.service';
import {SettingsIncidentReportModalComponent} from './settings-incident-report-modal/settings-incident-report-modal.component';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        CommonModule,
        TabsModule,
        FormsModule,
        FieldsModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        SafeHtmlPipeModule,
        AngularMultiSelectModule,
        UtilsModule
    ],
    declarations: [
        SettingsIncidentReportComponent,
        DetailedViewComponent,
        NotificationModalComponent,
        SettingsIncidentReportListComponent,
        SettingsIncidentReportModalComponent
    ],
    providers: [
        SettingsIncidentReportService
    ]
})
export class SettingsIncidentReportModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report.module.ts